const noResults = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = from_search ? 'overlay-search-' : '';
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');

  if (grid_container) {
    const grid = grid_container.querySelector('.grid');
    if (grid) {
      grid.innerHTML = '<div class="products__no-results column-xs-12">Sorry, no products matched your selection</div>';
    }
  }

  const pagination_count = grid_container.querySelector('.products__pagination-count');
  if (pagination_count) {
    pagination_count.classList.add('hidden');
  }

  const pagination = grid_container.querySelector('[data-pagination]');
  if (pagination) {
    pagination.classList.add('hidden');
  }

  const mobileFilterNav = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
  if (mobileFilterNav) {
    mobileFilterNav.classList.remove('active');
  }

  document.querySelectorAll(`[data-${prefix}total-filtered-items]`).forEach(el => {
    el.textContent = '0 items';
  });

  document.querySelectorAll(`[data-mobile-${prefix}filter-nav-view-results-count]`).forEach((el) => {
    el.textContent = '0';
  });
};

const removeNoResults = () => {
  const from_search = document.body.classList.contains('has-overlay-search');

  const gridContainer = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-collection-grid-container] .grid');

  if (!gridContainer) {
    return;
  }

  const no_results_div = gridContainer.querySelector('.products__no-results');
  if (!no_results_div) {
    return;
  }

  no_results_div.remove();
};

/**
 * The products request errored out or never answered. Distinct from noResults(): an empty
 * collection is an answer, this is the absence of one, so it offers a way out instead of
 * telling the shopper nothing matched.
 */
const loadFailed = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = from_search ? 'overlay-search-' : '';
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');

  if (!grid_container) {
    return;
  }

  const grid = grid_container.querySelector('.grid');
  if (grid) {
    grid.innerHTML = `
      <div class="products__load-failed column-xs-12" data-collection-load-failed>
        <p>We couldn't load these products just now.</p>
        <button type="button" class="btn btn--primary" data-collection-retry>Try again</button>
      </div>
    `;
  }

  const pagination_count = grid_container.querySelector('.products__pagination-count');
  if (pagination_count) {
    pagination_count.classList.add('hidden');
  }

  const pagination = grid_container.querySelector('[data-pagination]');
  if (pagination) {
    pagination.classList.add('hidden');
  }

  document.querySelectorAll(`[data-${prefix}total-filtered-items]`).forEach(el => el.classList.add('hide'));
};

const removeLoadFailed = () => {
  document.querySelectorAll('[data-collection-load-failed]').forEach(el => el.remove());
};

/**
 * Same idea as loadFailed(), for the search overlay. Separate because the overlay owns its own
 * results container and its retry has to re-run the search, not reload the collection.
 */
const searchFailed = () => {
  const grid = document.querySelector('[data-overlay-search-results] .grid');
  if (!grid) {
    return;
  }

  grid.innerHTML = `
    <div class="products__load-failed column-xs-12" data-search-load-failed>
      <p>We couldn't load these results just now.</p>
      <button type="button" class="btn btn--primary" data-search-retry>Try again</button>
    </div>
  `;
};

const removeSearchFailed = () => {
  document.querySelectorAll('[data-search-load-failed]').forEach(el => el.remove());
};

export {
  noResults,
  removeNoResults,
  loadFailed,
  removeLoadFailed,
  searchFailed,
  removeSearchFailed,
};
